import axios from 'axios';

export const STATUTS = {
  vert: { label: 'Validé', pastille: 'bg-emerald-500', carte: 'border-emerald-300 bg-emerald-50', texte: 'text-emerald-700', badge: 'bg-emerald-100 text-emerald-800 border-emerald-200' },
  orange: { label: 'À valider', pastille: 'bg-amber-500', carte: 'border-amber-300 bg-amber-50', texte: 'text-amber-700', badge: 'bg-amber-100 text-amber-800 border-amber-200' },
  rouge: { label: 'Aucune preuve', pastille: 'bg-red-500', carte: 'border-red-300 bg-red-50', texte: 'text-red-700', badge: 'bg-red-100 text-red-800 border-red-200' },
  na: { label: 'Non applicable', pastille: 'bg-slate-300', carte: 'border-slate-200 bg-slate-50', texte: 'text-slate-500', badge: 'bg-slate-100 text-slate-600 border-slate-200' },
};

export const StatutBadge = ({ statut, testId }) => (
  <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${STATUTS[statut].badge}`} data-testid={testId}>
    <span className={`h-2 w-2 rounded-full ${STATUTS[statut].pastille}`} /> {STATUTS[statut].label}
  </span>
);

export const totalPreuves = (nb) => (nb?.documents || 0) + (nb?.liens || 0) + (nb?.appli || 0);

export const dateFr = (iso) => (iso ? new Date(iso).toLocaleDateString('fr-FR') : '');

export const telecharger = async (url, nom, timeout = 20000) => {
  const res = await axios.get(url, { responseType: 'blob', timeout });
  const lien = document.createElement('a');
  lien.href = URL.createObjectURL(res.data);
  lien.download = nom;
  document.body.appendChild(lien);
  lien.click();
  lien.remove();
  setTimeout(() => URL.revokeObjectURL(lien.href), 1000);
};

export const Section = ({ titre, icone: Icone, compteur, children, testId }) => (
  <section className="space-y-2" data-testid={testId}>
    <h3 className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-slate-500">
      <Icone className="h-4 w-4 text-[#8DC63F]" /> {titre}
      {compteur !== undefined && <span className="rounded-full bg-slate-100 px-2 text-xs text-slate-600">{compteur}</span>}
    </h3>
    {children}
  </section>
);
